import {TextField} from "@mui/material";
import {statusTheme} from "../../../../config/themes/status-theme";
import {AttemptStatusType} from "../../../../config/enums";

function getNumericalLabelText(status: AttemptStatusType) {
  if (status === AttemptStatusType.Correct) return "Correct";
  if (status === AttemptStatusType.Incorrect) return "Incorrect answer";
  return "Numerics only accepted";
}

function getNumericalHelperText(
  status: AttemptStatusType,
  correctValue?: string,
) {
  if (status === AttemptStatusType.Incorrect)
    return `Correct answer: ${correctValue}`;
  return "";
}

export default function ProblemTextFieldUI({
  status,
  inputValue,
  correctValue,
  onChange,
  onSubmitQuestion,
}: {
  status: AttemptStatusType;
  inputValue: string;
  correctValue?: string;
  onChange: (value: string) => void;
  onSubmitQuestion: () => void;
}) {
  return (
    <TextField
      id="subjective-answer"
      value={inputValue}
      onChange={e => {
        const value = e.target.value;
        if (/^-?\d*\.?\d*$/.test(value)) {
          onChange(value);
        }
      }}
      variant="outlined"
      placeholder="Enter your answer here"
      error={status === AttemptStatusType.Incorrect}
      label={getNumericalLabelText(status)}
      helperText={getNumericalHelperText(status, correctValue)}
      fullWidth
      autoFocus
      disabled={
        status === AttemptStatusType.Correct ||
        status === AttemptStatusType.Incorrect
      }
      onKeyDown={e => {
        // Form submission on Enter key press
        if (e.key === "Enter") {
          e.preventDefault();
          onSubmitQuestion();
        }
      }}
      sx={{
        "& .MuiInputBase-root.Mui-disabled": {
          "& > fieldset": {
            borderColor: statusTheme[status]?.main,
          },
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "primary.contrastText",
        },
      }}
    />
  );
}
